/**
 * TORRAS · 顾客调研问卷（Q2 全站 Feedback + P1 PDP「还在犹豫？」）
 *
 * Config comes from sections/torras-survey.liquid (#tsv-config). This file owns the question
 * bank, the bottom-sheet UI, branching, the 30-day cooldown and the PostHog events.
 *
 * PostHog: both surveys are type=api. We emit the standard survey events so PostHog's own
 * results page works:
 *   survey shown     { $survey_id, $survey_name }
 *   survey sent      { $survey_id, $survey_name, $survey_response_<question id>, $survey_questions,
 *                      $survey_completed, $set: { $survey_responded/<id>: true } }
 *   survey dismissed { $survey_id, $survey_name, $survey_partially_completed, ... }
 * 🔴 `pid` below is the PostHog question id. Question text and choices must stay identical to
 *    the PostHog survey, or the results page splits answers. Change both sides together.
 *
 * Never auto-opens: everything starts from a click on [data-tsv-open].
 */
(function () {
  'use strict';
  if (window.__tSurveyInit) return;

  var cfgEl = document.getElementById('tsv-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  window.__tSurveyInit = true;

  var STORE_KEY = 'torras_survey_done_at';
  var TAB_KEY = 'torras_survey_tab_closed_at'; // × on the Feedback tab: hides only the tab
  var GEO_KEY = 'torras_survey_geo';
  var FORCE = /[?&]torras_survey=1\b/.test(location.search);

  /* ── Question bank ───────────────────────────────────────────── */
  var PHONE = '<svg class="tsv-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/></svg>';
  var ICO_YES = '<svg class="tsv-ico" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';
  var ICO_PART = '<svg class="tsv-ico" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/></svg>';
  var ICO_NO = '<svg class="tsv-ico" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>';
  var CHECK = '<svg class="tsv-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var CHEV = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
  var X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  var HELP_W1 = 'Checking an order or getting help';
  var FEEDBACK_W1 = "I've bought before and want to share feedback";

  var SURVEYS = {
    q2: {
      id: CFG.q2Id, name: 'Q2 · Visitor feedback (site-wide tab)', touchpoint: 'feedback_tab', meta: 'about 1 minute',
      questions: [
        { code: 'W1', pid: '172dee7b-88ab-4051-bffa-06d09e4cda4c', type: 'single', layout: 'rows', text: 'What brought you here today?',
          choices: ['Shopping for a screen protector', 'Shopping for a case, lens protector or charger', 'Comparing before I buy somewhere', HELP_W1, 'Just browsing', FEEDBACK_W1] },
        { code: 'W2', pid: 'ee6af56c-6f7c-4d99-8702-de23a97240c2', type: 'single', layout: 'grid2', icon: PHONE, text: 'Which phone are you shopping for?',
          choices: ['iPhone 18 Pro Max', 'iPhone 18 Pro', 'iPhone Duo', 'iPhone 17 series', 'Older iPhone', 'Samsung', 'Other'] },
        { code: 'W3', pid: 'afbc7b88-298b-4edb-9109-b77b699a0df5', type: 'single', layout: 'tiles3', text: 'Did you find what you were looking for?',
          choices: ['Yes', 'Partly', 'No'], icons: [ICO_YES, ICO_PART, ICO_NO] },
        { code: 'W4', pid: '4422c25d-470b-43c4-8427-27a206c58d9d', type: 'multi', layout: 'chips', text: "What's getting in the way today?", hint: 'Pick all that apply',
          choices: ['Price', 'Not sure it would fit my phone or case', 'Too many options to choose from', 'Shipping time or cost', "Hadn't heard of TORRAS", 'Not enough reviews', "Couldn't find my phone model", "Nothing, I'm about to buy"] },
        { code: 'W5', pid: '597c7a6a-e6b3-40ac-8faa-81400010cb71', type: 'rating', scale: 5, lo: 'Not sure at all', hi: 'Very sure', text: 'How sure are you about which screen protector is right for you?' },
        { code: 'W6', pid: '70ea9765-38e0-4fc8-9123-6453d17a4eeb', type: 'multi', layout: 'chips', text: 'What would help you decide?', hint: 'Pick all that apply',
          choices: ['A side-by-side comparison', 'Real photos on a phone', 'An install video', 'A list of cases it works with', 'More customer reviews', 'A lower price', 'Faster shipping', 'Something else'] },
        { code: 'W7', pid: '7a38fa53-288e-43da-864c-9cd3193342b7', type: 'multi', layout: 'grid2', text: 'Where else are you looking?', hint: 'Pick all that apply',
          choices: ['Amazon', 'Apple Store', "Other brands' sites", 'Nowhere else'] },
        { code: 'W8', pid: 'a9a1a0fd-191d-4442-b316-aacfb6d8a9ae', type: 'open', optional: true, text: "Anything else you'd like to tell us?",
          placeholder: 'What you were looking for, what was confusing, anything.',
          email: { pid: '1f95c4be-fb7d-4837-86df-15cd1d4b0d7b', text: "Email (optional), only if you'd like a reply" } }
      ]
    },
    p1: {
      id: CFG.p1Id, name: 'P1 · PDP still-deciding', touchpoint: 'pdp_still_deciding', meta: '20 seconds',
      questions: [
        { code: 'P1a', pid: '81d643dc-46e3-4f58-a7c3-bd1ea8328b92', type: 'multi', layout: 'chips', max: 2, text: 'Anything holding you back?', hint: 'Pick up to 2', product: true,
          choices: ['The price', 'Whether it holds up over time', 'How clear my screen will look', 'Whether it works with my case', 'Getting it on without bubbles', 'How it compares to other brands', 'Nothing, just looking'] },
        { code: 'P1b', pid: '847897b3-e480-439f-bb49-fa147b612e9f', type: 'open', optional: true, text: 'What would help you decide?', echo: 'P1a',
          placeholder: 'E.g. a photo of it with my case on',
          email: { pid: '06c1712c-5037-4c3c-a829-54e892e3678d', text: "Email (optional), only if you'd like a reply" } }
      ]
    }
  };

  /* ── Storage / gating ────────────────────────────────────────── */
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }

  function inCooldown() {
    var at = parseInt(lsGet(STORE_KEY), 10);
    if (!at) return false;
    return Date.now() - at < (CFG.cooldownDays || 30) * 864e5;
  }

  /* Shopify returns the visitor's IP country here (same source as its own geolocation
     prompt). Cached per session so it costs one small request per visit. */
  function getCountry(cb) {
    var cached = ssGet(GEO_KEY);
    if (cached) return cb(cached);
    var done = false;
    var finish = function (c) { if (done) return; done = true; if (c) ssSet(GEO_KEY, c); cb(c); };
    setTimeout(function () { finish(null); }, 4000);
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var h = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        finish(h ? String(h).toUpperCase() : null);
      })
      .catch(function () { finish(null); });
  }

  function tabClosed() {
    var at = parseInt(lsGet(TAB_KEY), 10);
    return !!at && Date.now() - at < (CFG.cooldownDays || 30) * 864e5;
  }

  function revealEntries() {
    document.querySelectorAll('[data-tsv-entry]').forEach(function (el) {
      if (el.getAttribute('data-tsv-entry') === 'tab' && tabClosed() && !CFG.designMode) return;
      el.hidden = false;
    });
    var pend = document.querySelector('.tsv-pdp');
    if (pend) unpend(pend); else mountPdpEntry(false);
    watchPdp();
  }
  function hideEntries() {
    document.querySelectorAll('[data-tsv-entry], .tsv-pdp').forEach(function (el) { el.hidden = true; });
  }

  /* The PDP entry is inserted the moment this script runs, invisible ("pending"), and only
     revealed once the visitor is known to be in the US. Inserting it after the async geo lookup
     instead pushed Klarna and everything below down ~60px after first paint (measured +0.007 CLS
     on desktop, 2026-10-10). Most traffic is US, so they now see no shift; a non-US visitor gets
     the space collapsed again. */
  function unpend(el) { el.style.visibility = ''; el.removeAttribute('aria-hidden'); el.removeAttribute('tabindex'); el.removeAttribute('data-tsv-pending'); }
  function dropPending() { var el = document.querySelector('.tsv-pdp[data-tsv-pending]'); if (el) el.remove(); }

  /* Re-mount if a section re-render (variant change, morph) throws the entry away. */
  var watching = false;
  function watchPdp() {
    if (watching || !document.getElementById('tsv-pdp-entry') || !window.MutationObserver) return;
    watching = true;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; if (!document.querySelector('.tsv-pdp') && !inCooldown()) mountPdpEntry(false); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function mountPdpEntry(pending) {
    var tpl = document.getElementById('tsv-pdp-entry');
    if (!tpl || document.querySelector('.tsv-pdp')) return;
    var anchor = null;
    try { anchor = CFG.pdpAnchor && document.querySelector(CFG.pdpAnchor); } catch (e) { anchor = null; }
    if (!anchor) return; // no buy box on this layout: no entry, by design
    /* 🔴 Never become a flex-row sibling of the buy buttons. bundle-ladder's side-by-side layout
       wraps CTA + Shop Pay in a horizontal `.tbl-row`; inserting inside it squeezed ADD TO CART to
       zero width (2026-10-10). Climb out of every horizontal flex/grid parent first. */
    var p = anchor.parentElement;
    while (p && p !== document.body) {
      var cs = getComputedStyle(p);
      var rowFlex = /flex/.test(cs.display) && !/column/.test(cs.flexDirection);
      var grid = /grid/.test(cs.display);
      if (!rowFlex && !grid && !p.classList.contains('tbl-row')) break;
      anchor = p; p = p.parentElement;
    }
    var el = tpl.content.firstElementChild.cloneNode(true);
    if (pending) { el.style.visibility = 'hidden'; el.setAttribute('aria-hidden', 'true'); el.setAttribute('tabindex', '-1'); el.setAttribute('data-tsv-pending', ''); }
    anchor.insertAdjacentElement('afterend', el);
  }

  /* ── Analytics ───────────────────────────────────────────────── */
  function capture(name, props) {
    if (FORCE && window.console) console.info('[torras-survey]', name, props); // QA trace; PostHog only loads on torraslife.com
    if (window.torrasAnalytics && window.torrasAnalytics.capture) { window.torrasAnalytics.capture(name, props); return; }
    if (window.posthog && typeof window.posthog.capture === 'function') {
      try { window.posthog.capture(name, props); } catch (e) { /* never break the page */ }
    }
  }

  function context(survey, src) {
    var c = { $survey_id: survey.id, $survey_name: survey.name, touchpoint: survey.touchpoint, entry: src, page_path: location.pathname };
    if (CFG.product) {
      c.product_handle = CFG.product.handle;
      c.product_title = CFG.product.title;
      c.variant_id = CFG.product.variantId;
    }
    return c;
  }

  function responseProps(survey, ans) {
    var out = {}, list = [];
    survey.questions.forEach(function (q) {
      var v = ans[q.code];
      var has = v !== undefined && v !== '' && !(Array.isArray(v) && !v.length);
      if (has) out['$survey_response_' + q.pid] = v;
      list.push({ id: q.pid, question: q.text, response: has ? v : null });
      if (q.email) {
        var e = ans[q.code + '_email'];
        if (e) out['$survey_response_' + q.email.pid] = e;
        list.push({ id: q.email.pid, question: q.email.text, response: e || null });
      }
    });
    out.$survey_questions = list;
    return out;
  }

  /* ── UI ──────────────────────────────────────────────────────── */
  var root = null, lastFocus = null, state = null;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function open(key, src, trigger) {
    var survey = SURVEYS[key];
    if (!survey || !survey.id) return;
    lastFocus = trigger || document.activeElement;
    state = { key: key, survey: survey, src: src, i: 0, hist: [], ans: {}, sent: false };
    root = document.createElement('div');
    root.className = 'tsv-root';
    root.innerHTML = '<div class="tsv-scrim" data-tsv-close></div><section class="tsv-sheet" role="dialog" aria-modal="true" aria-labelledby="tsv-title"></section>';
    document.body.appendChild(root);
    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKey);
    render();
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    capture('survey shown', context(survey, src));
  }

  function close(reason) {
    if (!root) return;
    var s = state;
    if (s && !s.sent) {
      var p = context(s.survey, s.src);
      p.at_question = s.survey.questions[s.i] ? s.survey.questions[s.i].code : null;
      p.close_reason = reason || 'close';
      var answered = Object.keys(s.ans).length > 0;
      if (answered) { Object.assign(p, responseProps(s.survey, s.ans)); p.$survey_partially_completed = true; }
      p.$set = {}; p.$set['$survey_dismissed/' + s.survey.id] = true;
      capture('survey dismissed', p);
    }
    var r = root; root = null; state = null;
    r.classList.remove('is-open');
    setTimeout(function () { if (r.parentNode) r.parentNode.removeChild(r); }, 320);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* gone */ } }
  }

  function sheet() { return root.querySelector('.tsv-sheet'); }

  function head(meta, pct) {
    return '<div class="tsv-handle" aria-hidden="true"></div>' +
      '<div class="tsv-head"><div class="tsv-head__row"><span class="tsv-meta">' + esc(meta) + '</span>' +
      '<button type="button" class="tsv-x" data-tsv-close aria-label="Close">' + X + '</button></div>' +
      (pct == null ? '' : '<div class="tsv-bar" aria-hidden="true"><i style="width:' + pct + '%"></i></div>') + '</div>';
  }

  function render() {
    var s = state, q = s.survey.questions[s.i], n = s.survey.questions.length;
    var last = nextIndex() === null;
    var meta = q.optional ? (s.i === n - 1 ? 'Last question · optional' : 'Optional') : 'Question ' + (s.i + 1) + ' of ' + n;
    if (s.i === 0 && s.survey.meta) meta += ' · ' + s.survey.meta;
    var auto = isAuto(q);
    var html = head(meta, Math.round(((s.i + 1) / n) * 100));

    if (q.product && CFG.product) {
      var pr = CFG.product;
      html += '<div class="tsv-prod">' + (pr.image ? '<img src="' + esc(pr.image) + '" alt="" width="48" height="48">' : '') +
        '<div><b>' + esc(pr.title) + '</b><small>' + esc([pr.variantTitle !== 'Default Title' ? pr.variantTitle : '', pr.price].filter(Boolean).join(' · ')) + '</small></div></div>';
    }
    if (q.echo && s.ans[q.echo] && s.ans[q.echo].length) {
      html += '<div class="tsv-said">You said:' + [].concat(s.ans[q.echo]).map(function (v) { return '<span>' + esc(v) + '</span>'; }).join('') + '</div>';
    }

    if (q.type === 'open') {
      html += '<label class="tsv-q" id="tsv-title" for="tsv-ta">' + esc(q.text) + '</label>' +
        '<textarea class="tsv-ta" id="tsv-ta" rows="4" placeholder="' + esc(q.placeholder || '') + '">' + esc(s.ans[q.code] || '') + '</textarea>';
      if (q.email) {
        html += '<div class="tsv-email"><label for="tsv-em">' + esc(q.email.text) + '</label>' +
          '<input id="tsv-em" type="email" inputmode="email" autocomplete="email" placeholder="you@example.com" value="' + esc(s.ans[q.code + '_email'] || '') + '"></div>' +
          '<span class="tsv-note">We use it only to reply to you. It won’t sign you up for emails.</span>';
      }
    } else {
      html += '<h2 class="tsv-q" id="tsv-title">' + esc(q.text) + '</h2>';
      if (q.hint) html += '<span class="tsv-hint">' + esc(q.hint) + '</span>';
      if (q.type === 'rating') {
        html += '<div class="tsv-seg" role="radiogroup" aria-labelledby="tsv-title">';
        for (var r = 1; r <= q.scale; r++) {
          html += '<button type="button" role="radio" aria-checked="' + (s.ans[q.code] === r) + '" data-tsv-val="' + r + '">' + r + '</button>';
        }
        html += '</div><div class="tsv-ends"><span>' + esc(q.lo) + '</span><span>' + esc(q.hi) + '</span></div>';
      } else {
        var multi = q.type === 'multi';
        var cur = s.ans[q.code];
        html += '<div class="tsv-opts tsv-opts--' + (q.layout || 'rows') + '" role="' + (multi ? 'group' : 'radiogroup') + '" aria-labelledby="tsv-title">';
        q.choices.forEach(function (c, idx) {
          var on = multi ? (cur || []).indexOf(c) > -1 : cur === c;
          var lone = q.layout === 'grid2' && idx === q.choices.length - 1 && q.choices.length % 2 === 1;
          html += '<button type="button" class="tsv-opt' + (lone ? ' tsv-opt--span2' : '') + '" data-tsv-val="' + idx + '" ' +
            (multi ? 'aria-pressed="' + on + '"' : 'role="radio" aria-checked="' + on + '"') + '>' +
            (q.icons ? q.icons[idx] : (q.icon || '')) +
            (q.layout === 'chips' ? CHECK + '<span>' + esc(c) + '</span>' : '<span>' + esc(c) + '</span>' + (q.layout === 'tiles3' ? '' : CHECK)) +
            '</button>';
        });
        html += '</div>';
      }
    }
    html += '<div class="tsv-err" role="alert"></div>';
    html += '<div class="tsv-foot-nav">' + (s.hist.length ? '<button type="button" class="tsv-back" data-tsv-back>Back</button>' : '') +
      (auto ? '' : '<button type="button" class="tsv-go" data-tsv-next>' + (last ? 'Send' : 'Next') + '</button>') + '</div>';

    sheet().innerHTML = html;
    sheet().scrollTop = 0;
    var focusEl = sheet().querySelector('.tsv-ta, .tsv-opt, .tsv-seg button, .tsv-go');
    if (focusEl) setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (e) { /* noop */ } }, 60);
  }

  /* Single choice and rating advance as soon as something is picked; multi / open keep NEXT. */
  function isAuto(q) { return q.type === 'single' || q.type === 'rating'; }

  function nextIndex() {
    var s = state, q = s.survey.questions[s.i];
    if (q.code === 'W1') {
      if (s.ans.W1 === HELP_W1) return null;
      if (s.ans.W1 === FEEDBACK_W1) return indexOf('W8');
    }
    return s.i + 1 < s.survey.questions.length ? s.i + 1 : null;
  }
  function indexOf(code) {
    var qs = state.survey.questions;
    for (var i = 0; i < qs.length; i++) if (qs[i].code === code) return i;
    return null;
  }

  function readOpen() {
    var q = state.survey.questions[state.i];
    if (q.type !== 'open') return;
    var ta = sheet().querySelector('#tsv-ta'), em = sheet().querySelector('#tsv-em');
    if (ta) state.ans[q.code] = ta.value.trim();
    if (em) state.ans[q.code + '_email'] = em.value.trim();
  }

  function answered(q) {
    if (q.optional) return true;
    var v = state.ans[q.code];
    return Array.isArray(v) ? v.length > 0 : v !== undefined && v !== '';
  }

  function next() {
    var s = state, q = s.survey.questions[s.i];
    readOpen();
    var err = sheet().querySelector('.tsv-err');
    if (!answered(q)) { err.textContent = 'Pick an answer to continue.'; return; }
    if (q.email && s.ans[q.code + '_email'] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.ans[q.code + '_email'])) {
      err.textContent = 'That email doesn’t look right. Fix it or leave it empty.'; return;
    }
    var n = nextIndex();
    if (n === null) return submit(s.key === 'q2' && s.ans.W1 === HELP_W1 ? 'help' : 'done');
    s.hist.push(s.i); s.i = n; render();
  }

  function submit(ending) {
    var s = state;
    var p = context(s.survey, s.src);
    Object.assign(p, responseProps(s.survey, s.ans));
    p.$survey_completed = ending === 'done';
    if (ending === 'help') p.ended = 'help_route';
    p.$set = {}; p.$set['$survey_responded/' + s.survey.id] = true;
    capture('survey sent', p);
    s.sent = true;
    lsSet(STORE_KEY, String(Date.now()));
    hideEntries();
    ending === 'help' ? renderHelp() : renderDone();
  }

  function linkRow(href, title, sub, ico) {
    return '<a class="tsv-link" href="' + esc(href) + '">' + ico + '<span><b>' + esc(title) + '</b><small>' + esc(sub) + '</small></span>' + CHEV + '</a>';
  }

  function renderDone() {
    var pdp = state.key === 'p1';
    var html = head('', null) +
      '<div class="tsv-done"><div class="tsv-done__ico">' + CHECK.replace('class="tsv-check"', '').replace('width="16" height="16"', 'width="28" height="28"') + '</div>' +
      '<h2 id="tsv-title">Thanks, that helps.</h2><p>Our team reads every answer.</p></div>';
    if (!pdp && CFG.links.shop) html += '<div class="tsv-links">' + linkRow(CFG.links.shop, CFG.links.shopLabel || 'Shop screen protectors', 'Back to browsing', PHONE) + '</div>';
    html += '<button type="button" class="tsv-go" data-tsv-close>' + (pdp ? 'Back to product' : 'Close') + '</button>';
    sheet().innerHTML = html;
    sheet().querySelector('.tsv-go').focus();
  }

  function renderHelp() {
    var L = CFG.links;
    var mail = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>';
    var shield = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>';
    var help = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>';
    var rows = '';
    if (L.contact) rows += linkRow(L.contact, 'Contact Us', 'Order status, damaged item, wrong size', mail);
    if (L.returns) rows += linkRow(L.returns, 'Returns & Warranty', 'Replacements and refunds', shield);
    if (L.faq) rows += linkRow(L.faq, 'FAQ', 'Fit, installing, shipping', help);
    sheet().innerHTML = head('', null) +
      '<h2 class="tsv-q" id="tsv-title">Help with an order is faster here</h2>' +
      '<p class="tsv-sub">For tracking, check the shipping email we sent you. For anything else, our team replies by email.</p>' +
      '<div class="tsv-links">' + rows + '</div>';
    var first = sheet().querySelector('.tsv-link, .tsv-x');
    if (first) first.focus();
  }

  function pick(btn) {
    var s = state, q = s.survey.questions[s.i];
    var idx = +btn.getAttribute('data-tsv-val');
    if (q.type === 'rating') {
      s.ans[q.code] = idx;
    } else if (q.type === 'single') {
      s.ans[q.code] = q.choices[idx];
    } else {
      var arr = (s.ans[q.code] || []).slice(), c = q.choices[idx], at = arr.indexOf(c);
      if (at > -1) arr.splice(at, 1);
      else { if (q.max && arr.length >= q.max) arr.shift(); arr.push(c); }
      s.ans[q.code] = arr;
    }
    var err = sheet().querySelector('.tsv-err'); if (err) err.textContent = '';
    sheet().querySelectorAll('[data-tsv-val]').forEach(function (b) {
      var v = +b.getAttribute('data-tsv-val');
      var on = q.type === 'rating' ? s.ans[q.code] === v : q.type === 'single' ? s.ans[q.code] === q.choices[v] : s.ans[q.code].indexOf(q.choices[v]) > -1;
      b.setAttribute(q.type === 'multi' ? 'aria-pressed' : 'aria-checked', String(on));
    });
    if (isAuto(q)) { var at = s.i; setTimeout(function () { if (state === s && s.i === at) next(); }, 220); }
  }

  function onClick(e) {
    var t = e.target.closest('[data-tsv-close],[data-tsv-back],[data-tsv-next],[data-tsv-val]');
    if (!t || !state) return;
    if (t.hasAttribute('data-tsv-close')) return close(t.classList.contains('tsv-scrim') ? 'scrim' : 'close_button');
    if (t.hasAttribute('data-tsv-back')) { readOpen(); state.i = state.hist.pop(); return render(); }
    if (t.hasAttribute('data-tsv-next')) return next();
    pick(t);
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); return close('escape'); }
    if (e.key !== 'Tab') return;
    var f = sheet().querySelectorAll('button, a[href], textarea, input');
    if (!f.length) return;
    var first = f[0], lastEl = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  }

  /* ── Boot ────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-tsv-tab-close]');
    if (x) {
      e.preventDefault();
      lsSet(TAB_KEY, String(Date.now()));
      var w = x.closest('[data-tsv-entry]'); if (w) w.hidden = true;
      capture('feedback_tab_closed', { $survey_id: CFG.q2Id, page_path: location.pathname });
      return;
    }
    var t = e.target.closest && e.target.closest('[data-tsv-open]');
    if (!t || root) return;
    e.preventDefault();
    open(t.getAttribute('data-tsv-open'), t.getAttribute('data-tsv-src'), t);
  });

  if (CFG.designMode || FORCE) return revealEntries();
  if (inCooldown()) return;
  if (!CFG.usOnly) return revealEntries();
  var known = ssGet(GEO_KEY);
  if (known) { if (known === 'US') revealEntries(); return; }
  mountPdpEntry(true);
  getCountry(function (c) { if (c === 'US') revealEntries(); else dropPending(); });
})();
